export default "__VITE_ASSET__CtHj0$gu__"